<fgb-page-header [pageTitle]="'games.page.title'" [showBalance]="true" [backButtonLink]="'/'" />

<div class="container mobile-content-wrapper">
  <div class="game-container text-white mt-lg-4 d-flex">
    <div class="game-item">
      <img [src]="'/images/trivia-game-banner.png' | contentAssetImage" alt="trivia game" />
      <div class="game-info p-3">
        <h6 class="title font-size-20 fw-bold mb-0 text-uppercase">{{ 'games.page.trivia.title' | translate }}</h6>
        <p class="description font-size-14">{{ 'games.page.description' | translate }}</p>

        <a [routerLink]="['/games/trivia']" class="font-size-14 fw-bold mb-1 text-white">{{ 'games.page.play' | translate }}</a>
      </div>
    </div>
    <div class="game-item">
      <img [src]="'/images/polls-game-banner.png' | contentAssetImage" alt="polls game" />
      <div class="game-info p-3">
        <h6 class="title font-size-20 fw-bold mb-0 text-uppercase">{{ 'games.page.polls.title' | translate }}</h6>
        <p class="description font-size-14">{{ 'games.polls.description' | translate }}</p>

        <a [routerLink]="['/games/polls']" class="font-size-14 fw-bold mb-1 text-white">{{ 'games.page.vote' | translate }}</a>
      </div>
    </div>
  </div>
</div>
